import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Billingdetails from "../../Details/Billingdetails/Billingdetails";

export default function Billingdetailsform() {

    const [billingsubmit, setBillingsubmit] = useState(false)

    const path = useLocation()

    function nexttab(){
        if(path.pathname === "/myaccountpage"){
            document.getElementById("useradministration-tab")?.click()
        }
        else{
            document.getElementById("references-tab")?.click() 
        }
        window.scrollTo(0, 0)
    }

    useEffect(() => {

        window.scrollTo(0, 0)

    }, [])

    return (
        <>
            {/* Billing details form start */}

            {billingsubmit === false ? <div>
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div>
                        <div className="createaccountpage_content_header">
                            Billing Details
                        </div>
                        <div className="createaccountpage_content_text">
                            The details of your bank and financial account.
                        </div>
                    </div>
                    <div>
                        <div className="createaccountpage_content_circle_wrap">
                            <div className="createaccountpage_content_circle">
                                <div className="createaccountpage_content_mask createaccountpage_content_half">
                                    <div className="createaccountpage_content_fill">
                                    </div>
                                </div>
                                <div className="createaccountpage_content_mask createaccountpage_content_full">
                                    <div className="createaccountpage_content_fill">
                                    </div>
                                </div>
                                <div className="inside-circle">2 of 3</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#billto" aria-expanded="true" aria-controls="billto">
                        Bill to
                    </button>
                    <div id="billto" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="billingbusinessname" className="createaccountpage_content_form_label">Business Name</label>
                                <input type="text" placeholder="name of your company" className="createaccountpage_content_form_input" name="billingbusinessname" id="billingbusinessname" />
                            </div>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="billingaddress_one" className="createaccountpage_content_form_label">Address 1</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="billingaddress_one" id="billingaddress_one" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="billingaddress_two" className="createaccountpage_content_form_label">Address 2</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="billingaddress_two" id="billingaddress_two" />
                            </div>

                            <div className="createaccountpage_content_form createaccountpage_content_form_address pe-0">

                                <div className="d-flex">
                                    <label htmlFor="billingcity" className="createaccountpage_content_form_label">city</label>
                                    <input type="text" placeholder="city name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="billingcity" name="billingcity" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="billingstate" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">State</label>
                                    <input type="text" placeholder="state name" className="createaccountpage_content_form_input createaccountpage_content_form_input_state" id="billingstate" name="billingstate" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="billtoCountry" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">Country</label>
                                    <input type="text" placeholder="country name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="billtoCountry" name="billtoCountry" />
                                </div>

                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="billingzipcode" className="createaccountpage_content_form_label">Postal Code</label>
                                <input type="text" placeholder="zip code" className="createaccountpage_content_form_input" id="billingzipcode" name="billingzipcode" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="billingphonenumber" className="createaccountpage_content_form_label">Phone</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" id="billingphonenumber" name="billingphonenumber" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#contactdetails" aria-expanded="true" aria-controls="contactdetails">
                        Contact Details
                    </button>
                    <div id="contactdetails" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="contactdetailscontactperson" className="createaccountpage_content_form_label">Contact Person</label>
                                <input type="text" placeholder="e.g John Doe" className="createaccountpage_content_form_input" name="contactdetailscontactperson" id="contactdetailscontactperson" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="contactdetailsemailaddress" className="createaccountpage_content_form_label">Email Address</label>
                                <input type="text" placeholder="insert your email address" className="createaccountpage_content_form_input" name="contactdetailsemailaddress" id="contactdetailsemailaddress" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="contactdetailscontactnumber" className="createaccountpage_content_form_label">Contact Number</label>
                                <input type="text" placeholder="the phone number" className="createaccountpage_content_form_input" name="contactdetailscontactnumber" id="contactdetailscontactnumber" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="contactdetailsfinancecontactperson" className="createaccountpage_content_form_label">Finance Contact Person</label>
                                <input type="text" placeholder="e.g John Doe" className="createaccountpage_content_form_input" name="contactdetailsfinancecontactperson" id="contactdetailsfinancecontactperson" />
                            </div>

                            <div className="createaccountpage_content_form createaccountpage_content_form_address pe-0">

                                <div className="d-flex">
                                    <label htmlFor="contactdetailsstate" className="createaccountpage_content_form_label">State</label>
                                    <input type="text" placeholder="state name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="contactdetailsstate" name="contactdetailsstate" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="contactdetailscountry" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">Country</label>
                                    <input type="text" placeholder="country name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="contactdetailscountry" name="contactdetailscountry" />
                                </div>

                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="contactdetailsemailaddrestwo" className="createaccountpage_content_form_label">Email Address</label>
                                <input type="text" placeholder="insert your email address" className="createaccountpage_content_form_input" id="contactdetailsemailaddrestwo" name="contactdetailsemailaddrestwo" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="contactdetailscontactnumbertwo" className="createaccountpage_content_form_label">Contact Number</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" id="contactdetailscontactnumbertwo" name="contactdetailscontactnumbertwo" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#bankinformation" aria-expanded="true" aria-controls="bankinformation">
                        Bank Information
                    </button>
                    <div id="bankinformation" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfobankname" className="createaccountpage_content_form_label">Bank Name</label>
                                <input type="text" placeholder="insert your bank name" className="createaccountpage_content_form_input" name="bankinfobankname" id="bankinfobankname" />
                            </div>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfobankaccountnumber" className="createaccountpage_content_form_label">Bank Account Number</label>
                                <input type="text" placeholder="bank account number" className="createaccountpage_content_form_input" name="bankinfobankaccountnumber" id="bankinfobankaccountnumber" />
                            </div>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfoaddress_one" className="createaccountpage_content_form_label">Address 1</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="bankinfoaddress_one" id="bankinfoaddress_one" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfoaddress_two" className="createaccountpage_content_form_label">Address 2</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="bankinfoaddress_two" id="bankinfoaddress_two" />
                            </div>

                            <div className="createaccountpage_content_form createaccountpage_content_form_address pe-0">

                                <div className="d-flex">
                                    <label htmlFor="bankinfocity" className="createaccountpage_content_form_label">city</label>
                                    <input type="text" placeholder="city name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="bankinfocity" name="bankinfocity" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="bankinfostate" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">State</label>
                                    <input type="text" placeholder="state name" className="createaccountpage_content_form_input createaccountpage_content_form_input_state" id="bankinfostate" name="bankinfostate" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="bankcountry" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">Country</label>
                                    <input type="text" placeholder="country name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="bankcountry" name="bankcountry" />
                                </div>

                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfozipcode" className="createaccountpage_content_form_label">Postal Code</label>
                                <input type="text" placeholder="zip code" className="createaccountpage_content_form_input" id="bankinfozipcode" name="bankinfozipcode" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfocontactperson" className="createaccountpage_content_form_label">Contact Person</label>
                                <input type="text" placeholder="e.g John Doe" className="createaccountpage_content_form_input" id="bankinfocontactperson" name="bankinfocontactperson" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfoemailaddress" className="createaccountpage_content_form_label">Email Address</label>
                                <input type="text" placeholder="insert your email address" className="createaccountpage_content_form_input" id="bankinfoemailaddress" name="bankinfoemailaddress" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="bankinfophonenumber" className="createaccountpage_content_form_label">Phone</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" id="bankinfophonenumber" name="bankinfophonenumber" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_content_save_next_bottom">
                    <button type="button" className="save_button" onClick={() => setBillingsubmit(true)}>Save</button>
                    <button type="button" className="next_button" onClick={() => nexttab()}>Next</button>
                </div>
            </div> : <Billingdetails />}

            {/* Billing details form over */}
        </>
    )

}